import React from 'react';
import { Svg } from 'src/components/Svg/Svg';

import classes from './SummaryInfo.scss';

const flag = require('../../../static/summaryInfo/Flag.svg');
const stars = require('../../../static/summaryInfo/stars.png');
const people = require('../../../static/summaryInfo/People.svg');
const peopleCloud = require('../../../static/summaryInfo/PeopleCloud.svg');

export const SummaryInfo: React.FC = React.memo(() => {
    return (
        <div className={classes.summaryInfo}>
            <ul>
                <li>
                    <div className={classes.summaryInfoImg}>
                        <img src={flag} alt="" />
                    </div>
                    <span>
                        In business <b>since 1990</b>
                    </span>
                </li>
                <li>
                    <div className={classes.summaryInfoImg}>
                        <img src={people} alt="" />
                    </div>
                    <b>300 staff</b>, based in the UK
                </li>
                <li>
                    <div className={classes.summaryInfoImg}>
                        <img src={peopleCloud} alt="" />
                    </div>
                    <span>
                        Trusted by over <b>2 million customers</b>
                    </span>
                </li>
                <li>
                    <div className={classes.summaryInfoImg}>
                        <Svg name="star" color="success" />
                    </div>
                    <span>
                        <b>137,500+</b> positive reviews
                    </span>
                    <img src={stars} className={classes.summaryInfo__stars} alt="" />
                </li>
            </ul>
        </div>
    );
});
